/** @jsxImportSource @emotion/react */

import { Divider } from "../../../components/Divider";
import { RouteFullScreenModal } from "../../../components/RouteFullScreenModal";
import { MutateAdyenAccountHolderForm } from "../components/MutateAdyenAccountHolderForm";

export const NewAdyenAccountHolderPage = () => {
  return (
    <RouteFullScreenModal title="Create new Adyen account holder">
      <Divider />
      <MutateAdyenAccountHolderForm />
    </RouteFullScreenModal>
  );
};
